class API {
    async expenseVsIncomeByTime({ year, month, ignoreCategories, ignoreTags }) {
        const params = {
            year,
            month
        };
        if (ignoreCategories) {
            params.ignoreCategories = ignoreCategories;
        }

        if (ignoreTags) {
            params.ignoreTags = ignoreTags;
        }

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }

        return await this.get(`/api/expenseVsIncomeByTime?${queryString}`);
    }

    async getMonthCategories({ year, month, ignoreCategories, ignoreTags, categoryType = undefined }) {
        const params = {
            year,
            month
        };

        if (categoryType) {
            params.categoryType = categoryType;
        }

        if (ignoreCategories) {
            params.ignoreCategories = ignoreCategories;
        }

        if (ignoreTags) {
            params.ignoreTags = ignoreTags;
        }

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }

        return await this.get(`/api/getMonthCategories?${queryString}`);
    }

    async getCurrentVSVariableExpenses({ year, month, ignoreCategories, ignoreTags }) {
        const params = {
            year,
            month
        };

        if (ignoreCategories) {
            params.ignoreCategories = ignoreCategories;
        }

        if (ignoreTags) {
            params.ignoreTags = ignoreTags;
        }

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }

        return await this.get(`/api/getCurrentVSVariableExpenses?${queryString}`);
    }

    async getMonthTransactions({ year, month, ignoreCategories, ignoreTags }) {
        const params = {
            year,
            month
        };

        if (ignoreCategories) {
            params.ignoreCategories = ignoreCategories;
        }

        if (ignoreTags) {
            params.ignoreTags = ignoreTags;
        }

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }

        return await this.get(`/api/getMonthTransactions?${queryString}`);
    }

    async serviceLogs() {
        return await this.get("/api/serviceLogs");
    }

    async backupLogs() {
        return await this.get("/api/backupLogs");
    }

    async accounts() {
        return await this.get("/api/getAccounts");
    }

    async lookups() {
        return await this.get("/api/lookups");
    }

    getUnapprovedTransactions() {
        return this.get(`/api/unapprovedTransactions`);
    }

    async getPendingApprovalCount() {
        return await this.get(`/api/pendingApprovalCount`);
    }

    async transactionsByCategory({
        year,
        month,
        categoryType,
        sortByAmount,
        includeCategoryIds,
        incomeOnly,
        expenseOnly,
        startTime,
        endTime,
        tagIds,
        searchText,
        ignoreCategories,
        ignoreTags,
        approvedOnly
    }) {
        const params = {
            year,
            month,
            categoryType,
            sortByAmount,
            includeCategoryIds,
            incomeOnly,
            expenseOnly,
            startTime,
            endTime,
            tagIds,
            searchText,
            approvedOnly
        };

        if (ignoreCategories) {
            params.ignoreCategories = ignoreCategories;
        }

        if (ignoreCategories) {
            params.ignoreTags = ignoreTags;
        }

        let queryString = new URLSearchParams();
        for (let key in params) {
            if (params[key]) {
                queryString.append(key, params[key]);
            }
        }

        return await this.get(`/api/transactionsByCategory?${queryString}`);
    }

    async monthComparison({ firstMonth, secondMonth }) {
        const params = {
            firstMonth,
            secondMonth
        };

        let queryString = new URLSearchParams();
        for (let key in params) {
            if (params[key]) {
                queryString.append(key, params[key]);
            }
        }

        return await this.get(`/api/monthComparison?${queryString}`);
    }

    async isAuthenticated() {
        const { response } = await this.get("/api/auth/isAuthenticated");
        return response;
    }

    async get(url) {
        return await this.callHttp({ method: "get", url });
    }

    async put(url, payload) {
        return await this.callHttp({ method: "put", url, payload });
    }

    async post(url, payload) {
        return await this.callHttp({ method: "post", url, payload });
    }

    async delete(url, payload) {
        return await this.callHttp({ method: "delete", url, payload });
    }

    async callHttp({ url, method, payload }) {
        const response = await this.fetchResponse({ url, method, payload });
        if (response.status === 401) {
            const loginRoute = `/api/auth/login`;
            window.location.replace(loginRoute);
            return;
        }

        const jsonResponse = await response.json();
        return { response: jsonResponse, status: response.status };
    }

    async fetchResponse({ url, method, payload }) {
        return await fetch(url, {
            method: method,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
    }

    async deleteTag(id) {
        return await this.delete(`/api/tags`, { tagId: id });
    }

    async deleteLog(runId) {
        return await this.delete(`/api/serviceLogs`, { runId });
    }
    async runAutomation() {
        return await this.get(`/api/runAutomation`);
    }

    async deleteCategory(id) {
        return await this.delete(`/api/categories`, { categoryId: id });
    }

    async deleteTransaction(id, type) {
        return await this.delete(`/api/transaction`, { id, type });
    }

    async addTag(description) {
        return await this.post(`/api/tags`, { description });
    }

    async addCategory(description) {
        return await this.post(`/api/categories`, { description });
    }

    async updateCredentials(params) {
        return await this.put(`/api/updateCredentials`, params);
    }

    async updateCredentials(params) {
        return await this.put(`/api/updateCredentials`, params);
    }

    async updateAccountStatus(params) {
        return await this.put(`/api/accountStatus`, params);
    }

    async bulkApproveTransactions(transactions) {
        return await this.post(`/api/bulkApproveTransactions`, { transactions });
    }

    async editTransaction(data) {
        return await this.post(`/api/editTransaction`, data);
    }

    async getBudgetLimits() {
        return await this.get(`/api/budgetLimits`);
    }

    async setBudgetLimit({ categoryId, amount }) {
        return await this.post(`/api/budgetLimits`, { categoryId, amount });
    }

    async getAnomalies({ year, month }) {
        const queryString = new URLSearchParams({ year, month });
        return await this.get(`/api/getAnomalies?${queryString}`);
    }

    async getTransactionHistory({ description, months = 6 }) {
        const queryString = new URLSearchParams({ description, months });
        return await this.get(`/api/transactionHistory?${queryString}`);
    }

    async getCategoryHistory({ categoryId, months = 6 }) {
        const queryString = new URLSearchParams({ categoryId, months });
        return await this.get(`/api/categoryHistory?${queryString}`);
    }

    async getRecurringTransactions() {
        return await this.get(`/api/recurringTransactions`);
    }

    async getRecurringExpenses({ year, month }) {
        const params = { year, month };
        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }
        return await this.get(`/api/recurringExpenses?${queryString}`);
    }

    async addRecurringTransaction({ description, categoryId, name, type }) {
        return await this.post(`/api/recurringTransactions`, { description, categoryId, name, type });
    }

    async deleteRecurringTransaction({ description }) {
        return await this.delete(`/api/recurringTransactions`, { description });
    }

    async getBudgetStatus({ year, month }) {
        const params = { year, month };
        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }
        return await this.get(`/api/budgetStatus?${queryString}`);
    }

    async getPushPublicKey() {
        return await this.get(`/api/push/publicKey`);
    }

    async getPushStatus() {
        return await this.get(`/api/push/status`);
    }

    async subscribeToPush(subscription) {
        return await this.post(`/api/push/subscribe`, subscription);
    }

    async unsubscribeFromPush(endpoint) {
        return await this.post(`/api/push/unsubscribe`, { endpoint });
    }

    async sendTestPush(message) {
        return await this.post(`/api/push/test`, { message });
    }
}

export default API = new API();
